import { useEffect } from 'react';
import { Carousel } from 'flowbite-react';

const PortoModal = ({ isOpen, onClose, portfolio, categories, formatDate }) => {
  // Handle ESC key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-gray-500/70 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white border border-gray-200 shadow-2xl rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 z-50 p-2"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          {/* Modal Body */}
          <div className="p-6 space-y-6">
            {/* Carousel */}
            {portfolio?.images?.length > 0 && (
              <Carousel
                indicators={true}
                className="rounded-lg overflow-hidden h-80 md:h-96"
                leftControl={<span className="text-gray-800 bg-white/80 p-2 rounded-full shadow">❮</span>}
                rightControl={<span className="text-gray-800 bg-white/80 p-2 rounded-full shadow">❯</span>}
              >
                {portfolio.images.map((img, idx) => (
                  <div key={idx} className="relative h-80 md:h-96 bg-gray-100">
                    <img
                      src={img.publicUrl}
                      alt={`Portfolio ${idx + 1}`}
                      className="h-full w-full object-contain"
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  </div>
                ))}
              </Carousel>
            )}
            
            {/* Content */}
            <div className="space-y-4 text-gray-800">
              <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
                  {portfolio?.title}
                </h3>
                {portfolio?.url && (
                  <a
                    href={portfolio.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 self-start transition-colors"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                    Live Demo
                  </a>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                {/* <div>
                  <p className="text-gray-500 font-medium">Category</p>
                  <p className="text-gray-700">{categories?.find(c => c.id === portfolio?.category_id)?.name || '-'}</p>
                </div> */}
                {/* <div>
                  <p className="text-gray-500 font-medium">Date</p>
                  <p className="text-gray-700">{portfolio?.date ? formatDate(portfolio.date) : '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 font-medium">Technology</p>
                  <p className="text-gray-700">{portfolio?.tech_stack || '-'}</p>
                </div> */}
              </div>

              {portfolio?.description && (
                <div>
                  <h4 className="font-medium mb-1">Project Details</h4>
                  <p className="whitespace-pre-line leading-relaxed text-gray-700">
                    {portfolio.description}
                  </p>
                </div>
              )}

              {portfolio?.achievements && (
                <div>
                  <h4 className="font-medium mb-5">Key Achievements</h4>
                  <ul className="list-disc pl-5">
                    {portfolio.achievements.split(';').map((ach, idx) => (
                      <li key={idx}>{ach.trim()}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortoModal;